import React, { useEffect, useState } from 'react';
import { TreeView } from '@mui/lab';
import { createStyles } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { useAnalytics, useAnalyticsTree } from '../../../hooks/entityHooks';
import { Node } from './node';
import {
  AccessTree,
  ENTITYTYPES,
  IAccess,
  requestType,
} from '../../../types/accessTree';
import { ReactComponent as Point } from '../../../assets/images/treePoint.svg';

const useStyles = makeStyles(
  createStyles({
    root: {
      flexGrow: 1,
      width: '100%',
    },

    elemenent: {
      flexGrow: 1,
      width: 25,
    },
  }),
);

type treeProps = {
  idEmployee: number;
  handleSetEntityLoader(val: boolean): void;
};

export const Tree = ({ idEmployee, handleSetEntityLoader }: treeProps) => {
  const { getTreeWithIndeterminate, accessTree } = useAnalyticsTree();
  const { changeAccess } = useAnalytics();
  const classes = useStyles();
  const [allTree, setAllTree] = useState<AccessTree>({
    checkboxType: 0,
    children: [],
    entityType: 0,
    id: 0,
    name: '',
  });

  const [requestData, setRequestData] = useState<requestType>({
    organizations: [],
    subdivisions: [],
  });

  const [expandedArray, setExpandedArray] = useState<string[]>([]);

  const handleExpandedArray = (id: number) => {
    const arr = expandedArray;
    const stringId = id.toString();
    if (arr.includes(stringId)) {
      arr.splice(arr.indexOf(stringId), 1);
    } else {
      arr.push(stringId);
    }
    setExpandedArray(arr);
  };

  const handleRequestData = (item: IAccess, itemType: ENTITYTYPES) => {
    switch (itemType) {
      case ENTITYTYPES.ORGANIZATION:
        const newState = requestData;
        newState.organizations.push(item);
        setRequestData(newState);
        break;
      case ENTITYTYPES.SUBDIVISION:
        const newState2 = requestData;
        newState2.subdivisions.push(item);
        setRequestData(newState2);
        break;
    }
  };

  const updateAccess = () => {
    changeAccess(idEmployee, requestData)
      .then(() => setRequestData({ organizations: [], subdivisions: [] }))
      .catch(() => {
        setRequestData({ organizations: [], subdivisions: [] });
      });
  };

  const handleAllTreeById = (id: number) => {
    setAllTree(allTree);
  };

  const searchNodeInTreeById = (id: number) => {
    return allTree;
  };

  const loadTree = async () => {
    handleSetEntityLoader(true);
    await getTreeWithIndeterminate(idEmployee);
    handleSetEntityLoader(false);
  };
  useEffect(() => {
    loadTree();
  }, []);
  useEffect(() => {
    setAllTree(accessTree);
  }, [accessTree]);

  return (
    <>
      <TreeView
        className={classes.root}
        defaultCollapseIcon={<Point />}
        key={0}
        defaultExpanded={expandedArray}
        expanded={expandedArray}
      >
        {allTree.name ? (
          <Node
            allTree={allTree}
            currentNode={allTree}
            handleAllTreeById={handleAllTreeById}
            setParentNode={setAllTree}
            searchNodeInTreeById={searchNodeInTreeById}
            isShowChildren={false}
            handleRequestData={handleRequestData}
            updateAccess={updateAccess}
            handleExpandedArray={handleExpandedArray}
          />
        ) : null}
      </TreeView>
    </>
  );
};
